<template>
    <tr>
        <td class="rr-shopping-cart__list-remove">
            <a @click="remove()">
                <i class="fal fa-times"></i>
                <span class="uk-hidden@s">{{ $t('rubinred.ecommerce.orders.common.remove') }}</span>
            </a>
        </td>
        <td class="rr-shopping-cart__list-data">
            <div class="uk-flex">
                <div class="uk-margin-small-right uk-position-relative">
                    <span v-if="item.thumbnail" v-html="item.thumbnail"></span>
                    <a :href="item.url" class="uk-position-cover"></a>
                </div>
                <div>
                    <span class="uk-text-small uk-text-muted">{{ item['main-category'] }}</span>
                    <p class="uk-margin-remove uk-text-large"><a :href="item.url" class="uk-link-reset">{{ item.name }}</a></p>
                    <p class="uk-margin-remove uk-text-small uk-text-muted">Cod. {{ item.code }}</p>
                    <div class="uk-text-small" data-reactive v-cloak>

                        <div class="uk-form-controls">
                            <div class="uk-grid-small uk-child-width-auto uk-grid">
                                <label>
                                    <input type="checkbox" class="uk-checkbox" :value="true" :checked="item.gift" @change="updateGift">
                                    {{ $t('rubinred.ecommerce.orders.common.is_gift') }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </td>
        <td class="rr-shopping-cart__list-options">
            <span class="uk-hidden@s">{{ $t('rubinred.ecommerce.orders.common.options') }}:</span>
            <span v-for="(key, value) in item.options">
                {{ key }}: {{ value }} <br>
            </span>
        </td>
        <td class="rr-shopping-cart__list-quantity">
            <span class="uk-hidden@s">{{ $t('rubinred.ecommerce.orders.common.quantity') }}:</span>
            <div class="quantity-selector uk-flex-inline uk-flex-middle">
                <quantity-input :value="item.quantity" :global="false" @quantity-changed="updateQuantity" ref="quantity"></quantity-input>
            </div>
        </td>
        <td class="rr-shopping-cart__list-price">
            <span class="uk-hidden@s">{{ $t('rubinred.ecommerce.orders.common.price') }}:</span>
            <span>{{ Utils.Currencies.toHuman(item.pricing.price) }}</span>
            <div class="uk-text-muted" v-if="item.pricing.reduced">
                <del>{{ Utils.Currencies.toHuman(item.pricing.original_price) }}</del>
                <span class="uk-badge">-{{ item.pricing.percentage }}%</span>
            </div>
        </td>
        <td class="rr-shopping-cart__list-total uk-text-right@m">
            <span class="uk-hidden@s">{{ $t('rubinred.ecommerce.orders.common.total_amount') }}:</span>
            <div class="uk-text-bold">{{ Utils.Currencies.toHuman(item.total) }}</div>
        </td>
    </tr>
</template>
<script>
  import {debounce} from 'lodash';

  export default {
    props: {
      item: {
        type: Object,
        required: true,
      }
    },
    mounted() {
      window.App.$on('quantity-changed', (quantity, vm) => {
        this.quantity = quantity;
      });
    },
    methods: {
      remove() {
        this.$store.dispatch('cart/remove', this.item.id);
      },
      updateQuantity: debounce(function (quantity, vm) {
        if (quantity === this.item.quantity) {
          return;
        }
        this.$store.dispatch('cart/add', {variant_id: this.item.variant_id, quantity: quantity - this.item.quantity})
          .then(({data}) => {
            if(data.success) {
              return;
            }
            App.UIkit.notification(data.message, {status: 'danger'});
            this.$refs.quantity.reset();
          });
      }, 300),
      updateGift() {
        this.$store.dispatch('cart/updateGiftSettings', {id: this.item.id, active: !this.item.gift});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/cart/RubinredCartItem.vue